import { generateRandomId } from 'utils/general-utils';
import {
  CLEAR_ALERT,
  ADD_ALERT,
  UPDATE_STEP,
  UPDATE_CURRENT_ATHLETE,
  UPDATE_SUGGESTED_FRIENDS
} from './Onboarding.actions';

export const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_STEP: {
      return { ...state, currentStep: payload.nextStep };
    }
    case ADD_ALERT: {
      const alert = { ...payload, id: generateRandomId() };
      return { ...state, alert };
    }
    case CLEAR_ALERT: {
      return { ...state, alert: null };
    }
    case UPDATE_CURRENT_ATHLETE: {
      return {
        ...state,
        currentAthlete: { ...state.currentAthlete, ...payload }
      };
    }
    case UPDATE_SUGGESTED_FRIENDS: {
      return {
        ...state,
        suggestions: payload.suggestions
      };
    }
    default: {
      throw new Error(`${type} - not recognized`);
    }
  }
};

export default { reducer };
